"use strict";
// returns the kevel sizeId's for all the sizes that are passed in
Object.defineProperty(exports, "__esModule", { value: true });
exports.kevelSizeIdToSize = exports.getAdTypes = void 0;
// mapping comes from https://app.kevel.co/#!/9660/ad-sizes/
//
//
var AdSizeToKevelSizeId = {
    "728x90": 4,
    "300x250": 5,
    "160x600": 6,
    "180x150": 9,
    "88x31": 13,
    "120x60": 14,
    "125x125": 16,
    "320x50": 23,
    "300x600": 43,
    "970x90": 77,
    "100x100": 91,
    "200x300": 318,
    "800x300": 1218,
};
var getAdTypes = function (sizes) {
    var ids = [];
    for (var _i = 0, sizes_1 = sizes; _i < sizes_1.length; _i++) {
        var size = sizes_1[_i];
        var key = size.join("x");
        var value = AdSizeToKevelSizeId[key];
        if (value) {
            ids.push(value);
        }
    }
    return ids;
};
exports.getAdTypes = getAdTypes;
// return the size array for the size that matches the sizeId passed in
var kevelSizeIdToSize = function (sizeId) {
    for (var _i = 0, _a = Object.entries(AdSizeToKevelSizeId); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value === sizeId) {
            return key.split("x").map(function (n) {
                return Number(n);
            });
        }
    }
};
exports.kevelSizeIdToSize = kevelSizeIdToSize;
exports.default = exports.getAdTypes;
